





















































































import FormSelect from "@/components/FormSelect.vue";
import FormInput from "@/components/FormInput.vue";
import FormInputError from "@/components/FormInputError.vue";
import { DeliveryConfig, SMTPConfig } from "@/types/alert";
import { Features } from "@/types/settings";
import FormValidation from "@/mixins/form-validation";
import { Component, Mixins } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({
  components: {
    FormSelect,
    FormInput,
    FormInputError,
  },
})
export default class AlertsDeliveryConfigForm extends Mixins(FormValidation) {
  created() {
    // Simple caching
    // Only fetch if custom SMTP enabled. i.e. do not fetch for Analytics
    if (!this.SMTPConfig && this.features["alert-config"] === 1) {
      this.$store.dispatch("alerts/fetchSMTPConfig");
    }
  }

  @State(state => state.alerts.SMTPConfig)
  SMTPConfig!: SMTPConfig;

  @Getter("alerts/isSMTPConfigSet") isSMTPConfigSet!: boolean;
  @Getter("settings/activeCacheFeatures") features!: Features;

  deliveryConfig: DeliveryConfig = {
    id: 0,
    delivery_type: "",
    email: "",
    slack_url: "",
    slack_channel: "",
  };

  title = "Save";

  isSaving = false;

  deliveryTypeOpts = {
    email: "email",
    slack: "slack",
  };

  deliveryTypeError = "";
  emailError = "";
  slackURLError = "";
  slackChannelError = "";

  addDeliveryConfig() {
    this.deliveryTypeError = this.validateString(this.deliveryConfig.delivery_type, "Please choose a delivery type");
    if (this.deliveryTypeError) return;

    if (this.deliveryConfig.delivery_type === "email") {
      this.emailError = this.validateEmail(this.deliveryConfig.email);
      if (this.emailError) return;
    } else if (this.deliveryConfig.delivery_type === "slack") {
      this.slackURLError = this.validateString(this.deliveryConfig.slack_url);
      if (this.slackURLError) return;
      this.slackChannelError = this.validateString(this.deliveryConfig.slack_channel);
      if (this.slackChannelError) return;
    }

    this.$ga.button("Add delivery config");

    this.title = "Saving";
    this.isSaving = true;

    this.$store.dispatch("alerts/addDeliveryConfig", this.deliveryConfig).then(() => {
      this.title = "Saved!";
      this.isSaving = false;
      setTimeout(() => {
        this.title = "Save";
        this.cancel();
      }, 1000);
    });
  }

  cancel() {
    this.$ga.toggle("Hide add delivery config");
    this.$store.dispatch("alerts/setShowAddDeliveryConfig", false);
  }
}
